module.exports = __webpack_public_path__ + "static/media/meme.76e44a4c.gif";